export default __webpack_public_path__ + "static/media/GreenFrame02.85d13b09.png";